import { LabelGrouping } from '@aibees/elephant/types/label';
import { useTheme } from '@mui/material';
import { useMemo } from 'react';

export const useLabelColors = () => {
  const theme = useTheme();

  return useMemo(
    () => ({
      primary: theme.palette.primary[500],
      success: theme.palette.success[500],
      warning: theme.palette.warning[500],
      error: theme.palette.error[500],
      grey: theme.palette.grey[500],
    }),
    [theme]
  );
};

export const useListColor = (grouping: LabelGrouping) => {
  const theme = useTheme();

  return useMemo(
    () =>
      grouping === LabelGrouping.COMPANY
        ? theme.palette.primary[500]
        : theme.palette.success[500],
    [theme, grouping]
  );
};
